import { useQuery } from '@tanstack/react-query'
import type { OpportunitySummaryResponse } from 'backend/types'
import { getOpportunitySummary } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseOpportunitySummaryOptions {
  startAt?: string // YYYY-MM-DD形式の集計開始日
  enabled?: boolean // データ取得を有効化するか（デフォルト: true）
}

/**
 * オポチュニティサマリーを取得するカスタムフック
 *
 * @param options - フックオプション（startAt, enabled）
 * @returns TanStack Query の結果（data, isLoading, error, refetch など）
 *
 * @example
 * ```tsx
 * const { data, isLoading, error, refetch } = useOpportunitySummary({
 *   startAt: '2025-01-01',
 * })
 * ```
 */
export function useOpportunitySummary(options: UseOpportunitySummaryOptions = {}) {
  const { startAt, enabled = true } = options

  return useQuery<OpportunitySummaryResponse, Error>({
    queryKey: queryKeys.opportunity.summary({ startAt }),
    queryFn: async () => {
      return getOpportunitySummary(startAt)
    },
    enabled,
  })
}
